<template>
  <div class="projects-table">
    <button-group />
    <div class="table-container">
      <table class="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Company</th>
          </tr>
        </thead>
        <!-- Skeleton Loading State -->
        <transition name="fade" mode="out-in">
          <tbody v-if="isLoadingSync" key="loading" class="skeleton-tbody">
            <tr
              v-for="n in skeletonRows"
              :key="`skeleton-${n}`"
              class="skeleton-row"
            >
              <td><div class="skeleton skeleton-text"></div></td>
              <td><div class="skeleton skeleton-text"></div></td>
              <td><div class="skeleton skeleton-text"></div></td>
            </tr>
          </tbody>

          <!-- Actual Data -->
          <tbody v-else-if="projects.length > 0" key="data" class="data-tbody">
            <tr v-for="(project, i) in projects" :key="i">
              <td>{{ project.id }}</td>
              <td :title="project.name">
                <a
                  href="#"
                  @click.prevent="editProject(project)"
                  class="entity-link"
                  >{{ truncate(project.name, 35)
                  }}<span class="icon is-small edit-icon"
                    ><i class="fas fa-edit"></i></span
                ></a>
              </td>
              <td :title="project.company.name">
                <a
                  href="#"
                  @click.prevent="editCompany(project.company)"
                  class="entity-link"
                  >{{ truncate(project.company.name, 35)
                  }}<span class="icon is-small edit-icon"
                    ><i class="fas fa-edit"></i></span
                ></a>
              </td>
            </tr>
          </tbody>

          <!-- Empty State -->
          <tbody v-else key="empty">
            <tr>
              <td colspan="3" class="has-text-centered empty-state">
                <div class="empty-state-content">
                  <p class="has-text-grey">
                    <span class="icon is-large">
                      <i class="fas fa-project-diagram fa-2x"></i>
                    </span>
                  </p>
                  <p class="has-text-grey">No projects found</p>
                </div>
              </td>
            </tr>
          </tbody>
        </transition>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ButtonGroup from "@/components/ButtonGroup.vue";
export default {
  components: {
    "button-group": ButtonGroup,
  },
  data() {
    return {
      skeletonRows: 10, // Number of skeleton rows to show during loading
    };
  },
  computed: {
    ...mapState(["projects", "isLoadingSync"]),
  },

  methods: {
    ...mapActions(["fetchList", "openProjectModal", "openCompanyModal"]),
    truncate(text, length) {
      if (!text) return "";
      return text.length > length ? text.substring(0, length) + "..." : text;
    },
    editProject(project) {
      this.openProjectModal(project);
    },
    editCompany(company) {
      this.openCompanyModal(company);
    },
  },
  mounted() {
    this.fetchList();
  },
};
</script>

<style scoped>
.table-container {
  position: relative;
  min-height: 400px;
  transition: min-height 0.3s ease;
}

/* Skeleton Loading Styles */
.skeleton-row {
  pointer-events: none;
}

.skeleton {
  background: linear-gradient(90deg, #f0f0f0 0%, #f8f8f8 50%, #f0f0f0 100%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
  display: inline-block;
}

.skeleton-text {
  height: 20px;
  width: 80%;
  max-width: 120px;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

/* Vue Transition Classes */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

/* Empty state styling */
.empty-state {
  padding: 3rem !important;
}

.empty-state-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.empty-state-content .icon {
  color: #dbdbdb;
}

/* Entity link hover effects */
</style>
